// =============================================================
// 航富通（标准版）套餐数据
// 来源：用户提供口径
//   - 手机套餐 标配 888 元
//   - 通用套餐 标配 1688 元
//   - 平板套餐 标配 暂无
//   - 一体机套餐 标配 暂无
// 说明：价格为「官方标配」档；暂无档的套餐暂未开放。
// =============================================================

export const packages = [
  { hardware: '手机套餐', standardPrice: '888元', available: true },
  { hardware: '通用套餐', standardPrice: '1688元', available: true },
  { hardware: '平板套餐', standardPrice: '暂无', available: false },
  { hardware: '一体机套餐', standardPrice: '暂无', available: false },
]



// WEBPACK FOOTER //
// ./src/site/data/packages.js